export default __webpack_public_path__ + "92541e7164cad605866fcd8419a537a7.svg";